import { ArrowBack } from "@mui/icons-material";
import { Box, Stack, Typography } from "@mui/material";
import { getTranslation } from "common";
import FlowentiButton from "components/flowenti-ui-kit/FlowentiButton";
import SlaDiagramSurface from "components/sla/SlaDiagramSurface";
import { useSelectedOrganization, useTranslations } from "hooks";
import { SLA_DIAGRAM_TEXT_KEYS } from "model/slaDiagramModel";
import { useNavigate } from "react-router-dom";

/**
 * Vista **Diagramma SLA** (`/dashboard/process/sla-diagram`), aperta dal
 * pulsante "Diagramma SLA" nella barra dei Modelli (`ProcessLibraryToolbar`).
 *
 * Monta la stessa `SlaDiagramSurface` che prima era una tab di Operazioni
 * (rotta storica `processes/sla-diagram`, ora redirect qui): scelta del
 * modello, revisione e comportamento restano quelli della superficie. Il primo
 * segmento della rotta e' `process`, cosi' il selettore di organizzazione del
 * Dashboard resta visibile come nella pagina Modelli.
 */
const SlaDiagram = () => {
  const organization = useSelectedOrganization();
  const translations = useTranslations();
  const navigate = useNavigate();

  if (!organization?.id) return null;

  return (
    <Stack
      spacing={2}
      height="100%"
      minHeight={0}
      sx={{ boxSizing: "border-box", p: { xs: 2, lg: 3 } }}
    >
      <Stack direction="row" spacing={2} alignItems="center">
        <FlowentiButton
          id="sla-diagram-back"
          variant="outlined"
          startIcon={<ArrowBack />}
          onClick={() => navigate("/dashboard/process")}
        >
          {getTranslation(translations, "generic.back.caption")}
        </FlowentiButton>
        <Typography id="sla-diagram-title" variant="h6" fontWeight={700} noWrap>
          {getTranslation(translations, SLA_DIAGRAM_TEXT_KEYS.title)}
        </Typography>
      </Stack>
      <Box flex={1} minHeight={0} sx={{ width: "100%" }}>
        <SlaDiagramSurface idorganization={organization.id} />
      </Box>
    </Stack>
  );
};

export default SlaDiagram;
